import { combineReducers } from "redux";
import authReducer from "@/components/features/auth/authSlice";
import usersReducer from "@/components/features/users/userSlice";
import albumReducer from "@/components/features/album/albumSlice";
import tasksReducer from "@/components/features/tasks/taskSlice";
import transactionReducer from "@/components/features/transaction/transactionSlice";
import mediaReducer from "@/components/features/media/mediaSlice";

const rootReducer = combineReducers({
  login: authReducer,
  users: usersReducer,
  albums: albumReducer,
  tasks: tasksReducer,
  transaction: transactionReducer,
  media: mediaReducer,
  // add other reducers here
});

export default rootReducer;
